"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Certificate = void 0;
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const certificateError_1 = require("./model/error/certificateError");
class Certificate {
    constructor(instance) {
        this.instance = instance;
    }
    createCertificate(token, tag, publicKey, privateKey, address, tx, payload, timestamp, issuerAddress, amount) {
        return new Promise((resolve, reject) => {
            const URL = '/certificates';
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = {
                tag,
                public_key: publicKey,
                private_key: privateKey,
                address,
                tx,
                payload,
                timestamp,
                issuer_address: issuerAddress,
                amount
            };
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.post(URL, data, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'createCertificate'));
            });
        });
    }
    getAllCertificates(token) {
        return new Promise((resolve, reject) => {
            const URL = '/certificates';
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'getAllCertificates'));
            });
        });
    }
    getCertificateByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/certificates/${id}`;
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.get(URL, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'getCertificateByID'));
            });
        });
    }
    getCertificateByAdress(token, address) {
        return new Promise((resolve, reject) => {
            const URL = `/certificates`;
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: { Authorization: authStr },
                params: {
                    address,
                },
            };
            this.instance.get(URL, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'getCertificateByID'));
            });
        });
    }
    deleteCertificateByID(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/certificates/${id}`;
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.delete(URL, config)
                .then((res) => {
                resolve(res.data.message === 'Successfully deleted');
            })
                .catch((err) => {
                reject(this.handleError_(err, 'deleteCertificateByID'));
            });
        });
    }
    updateCertificateByID(token, newCertificateInfo) {
        const theCertificateInfo = newCertificateInfo;
        return new Promise((resolve, reject) => {
            const URL = `/certificates/${newCertificateInfo.id}`;
            delete theCertificateInfo.id;
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const authStr = 'Bearer '.concat(token);
            const config = { headers: { Authorization: authStr } };
            this.instance.put(URL, theCertificateInfo, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'updateCertificateByID'));
            });
        });
    }
    generateCertificateNem(token, uuid, payload, amount, owner, tag, totpToken, bulk) {
        return new Promise((resolve, reject) => {
            const URL = '/certificates/generate';
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = { uuid, payload, amount, owner, tag, token: totpToken, bulk };
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: { Authorization: authStr },
                timeout: 100000,
            };
            this.instance.post(URL, data, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'generateCertificateNem'));
            });
        });
    }
    generateBulkCertificateNem(token, payloadList, amount, owner, tag, totpToken) {
        return new Promise((resolve, reject) => {
            const URL = '/certificates/generateBulk';
            if (!token) {
                reject(new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = { payloadList, amount, owner, tag, token: totpToken };
            const authStr = 'Bearer '.concat(token);
            const config = {
                headers: { Authorization: authStr },
                timeout: 100000,
            };
            this.instance.post(URL, data, config)
                .then((res) => {
                const certificate = res.data;
                resolve(certificate);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'generateBulkCertificateNem'));
            });
        });
    }
    handleError_(error, log) {
        if (error.response.data.error !== undefined) {
            return new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.error);
        }
        else {
            return new certificateError_1.CertificateError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.Certificate = Certificate;
//# sourceMappingURL=certificate.js.map